/**
 * Get the API URL from environment variables
 * This handles different environments (development, production)
 * @returns {string} The base API URL
 */
export const getApiUrl = () => {
    // Check for _env_ global variable first (used in production)
    if (window._env_ && window._env_.API_URL) {
        return window._env_.API_URL;
    }

    // Fall back to the React environment variable
    if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL;
    }

    // Default fallback (local development)
    return '/api';
}; 